// 契約ステータス(有効契約:active 仮解約:provisional_cancellation 解約予定:cancellation 未契約:no_contract)
export const enum CONTRACT_STATUS_CODE {
  ACTIVE = "active",
  PROVISIONAL_CANCELLATION = "provisional_cancellation",
  CANCELLATION = "cancellation",
  NO_CONTRACT = "no_contract",
}
